import { Shell } from "@/components/layout/Shell";
import { DossieAberturaWizard } from "@/components/dossies/DossieAberturaWizard";

export default function DossieNovo() {
  return <Shell><DossieAberturaWizard /></Shell>;
}
